<div class="snack-bar-items">
    <mat-progress-spinner diameter="30" [value]="progressbarValue"></mat-progress-spinner>
    <div class="spinner-val"> {{curSec}} </div>
    <span class="message">{{data?.message}}</span>
    <button mat-button class="undo-btn" color="primary" (click)="snackBarRef.dismissWithAction()">
        <mat-icon>undo</mat-icon>
        {{data?.action}}
    </button>
    <button mat-icon-button class="close-icon" (click)="snackBarRef.dismiss()">
        <mat-icon>close</mat-icon>
    </button>
</div>
